import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { Mic, Shield, Wallet } from 'lucide-react'

export function PitchCta({
  sessionsAvailable,
  canStartSession,
  canStart,
  disabledReason,
  onStartPitch,
  onBuySession,
  isLoading,
  promoSession,
}: {
  sessionsAvailable: number
  canStartSession: boolean
  canStart: boolean
  disabledReason?: string
  onStartPitch?: () => void
  onBuySession?: () => void
  isLoading?: boolean
  promoSession?: boolean
}) {
  const hasSessions = sessionsAvailable > 0

  return (
    <div className="mt-6 rounded-xl border border-border bg-card/30 px-5 py-4">
      <div className="flex items-center justify-between">
        <div>
          {!canStart && disabledReason ? (
            <>
              <p className="text-sm font-medium text-foreground">{disabledReason}</p>
              <p className="mt-0.5 text-xs text-muted-foreground">
                Complete the requirements above to start
              </p>
            </>
          ) : hasSessions && promoSession ? (
            <>
              <p className="text-sm font-medium text-foreground">
                <span className="mr-1.5 inline-flex items-center rounded-full bg-emerald-500/10 px-2 py-0.5 text-xs font-medium text-emerald-400">
                  Limited offer
                </span>
                1 free AI session available
              </p>
              <p className="mt-0.5 text-xs text-muted-foreground">
                Limited-time offer, no credit card required
              </p>
            </>
          ) : hasSessions ? (
            <>
              <p className="text-sm font-medium text-foreground">
                You have{' '}
                <span className="text-[#f97316]">
                  {sessionsAvailable} {sessionsAvailable === 1 ? 'session' : 'sessions'}
                </span>{' '}
                available
              </p>
              <p className="mt-0.5 text-xs text-muted-foreground">1 session will be used</p>
            </>
          ) : canStartSession ? (
            <>
              <p className="text-sm font-medium text-foreground">Pay from your wallet</p>
              <p className="mt-0.5 text-xs text-muted-foreground">
                This session is charged to your wallet balance
              </p>
            </>
          ) : (
            <>
              <p className="text-sm font-medium text-foreground">Wallet balance too low</p>
              <p className="mt-0.5 text-xs text-muted-foreground">
                Top up your wallet to continue, and pay only for what you use
              </p>
            </>
          )}
        </div>
        {canStartSession ? (
          <CtaButton
            size="lg"
            onClick={onStartPitch}
            disabled={!canStart}
            loading={isLoading}
            icon={<Mic className="size-4" />}
          >
            Start AI session
          </CtaButton>
        ) : (
          <CtaButton size="lg" onClick={onBuySession} icon={<Wallet className="size-4" />} arrow>
            Top up wallet
          </CtaButton>
        )}
      </div>
      <div className="mt-3 flex items-center gap-2 rounded-lg bg-white/[0.04] px-3 py-2 text-xs text-foreground/60">
        <Shield className="size-3.5 shrink-0 text-foreground/40" />
        <span>Recording shared with investors only with your permission</span>
      </div>
    </div>
  )
}
